import React from 'react';

import CustomDropdown from '@/components/CustomDropdown';
import CommonImage from '@/components/CommonImage';
const UpdateTaskModal = () => {
	return (
		<div className="popup-wrapper">
			<div className="common-popup update-task-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Update task</h3>
					</div>
					<div className="close-btn">
						<CommonImage alt="close" src="/icons/close.svg" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="row">
						<div className="col-md-12">
							<div className="form-group">
								<label htmlFor="collection">Select task*</label>
								<CustomDropdown
									title="Project type*"
									onItemClick={() => {}}
									selectedItem={''}
									items={[]}
								/>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group">
								<label htmlFor="collection">Sewing completed by</label>
								<CustomDropdown
									title="Project type*"
									onItemClick={() => {}}
									selectedItem={''}
									items={[]}
								/>
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group">
								<label htmlFor="collection">Sewing Qty</label>
								<input type="text" />
							</div>
						</div>
						<div className="col-md-12">
							<div className="form-group">
								<label htmlFor="collection">Comment</label>
								<input type="text" />
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button outline size32 ml-2">Cancel</button>
						<button className="button size32 ml-2">Update</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default UpdateTaskModal;
